(function () {
    'use strict';

    angular
        .module('editorApp')
        .component('editorStructureComponentEditor', {
            bindings: {
                part: '<',
                onClose: '&'
            },
            templateUrl: 'app/entities/editor-structure/components/editor-structure-component-editor.html',
            controller: EditorStructureComponentEditor
        })
        .component('editorStructureComponentIcon', {
            bindings: {
                type: '<'
            },
            template: [
                '<span class="editor-structure-component-type-icon" aria-hidden="true">',
                '<svg viewBox="0 0 20 20" focusable="false">',
                '<g ng-if="$ctrl.type === \'hanger\'">',
                '<circle cx="10" cy="10" r="7.5" fill="none" stroke="currentColor" stroke-width="2"/>',
                '<circle cx="10" cy="10" r="3" fill="none" stroke="currentColor" stroke-width="2"/>',
                '</g>',
                '<circle ng-if="$ctrl.type === \'punch\'" cx="10" cy="10" r="7.5" fill="none"',
                ' stroke="currentColor" stroke-width="2"/>',
                '<path ng-if="$ctrl.type === \'slot\'" d="M2.5 4.5h15v6h-5v5h-5v-5h-5z" fill="none"',
                ' stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>',
                '<rect ng-if="$ctrl.type === \'hole\'" x="2.5" y="6" width="15" height="8" rx="1"',
                ' fill="none" stroke="currentColor" stroke-width="1.8"/>',
                '</svg>',
                '</span>'
            ].join('')
        });

    EditorStructureComponentEditor.$inject = ['$scope', '$document', '$element', '$uibModal'];

    function EditorStructureComponentEditor($scope, $document, $element, $uibModal) {
        var vm = this;
        var nextId = 0;
        var cutlineRatio = 1;
        var stopDrag = angular.noop;

        // TODO: 组件类型与可选组件接入后台组件管理后替换为接口数据
        vm.categories = [
            { key: 'hanger', label: '挂件孔' },
            { key: 'punch', label: '穿孔' },
            { key: 'slot', label: '插口' },
            { key: 'hole', label: '插孔' }
        ];
        vm.catalog = {
            hanger: [
                { name: '挂孔3mm', type: 'hanger', width: 3, height: 3 },
                { name: '挂孔2.5mm', type: 'hanger', width: 2.5, height: 2.5 },
                { name: '指环孔23mm', type: 'hanger', width: 23, height: 23 }
            ],
            punch: [
                { name: '穿孔3mm', type: 'punch', width: 3, height: 3 },
                { name: '穿孔5mm', type: 'punch', width: 5, height: 5 }
            ],
            slot: [
                { name: '插口13*3.5mm', type: 'slot', width: 13, height: 3.5 },
                { name: '插口20*4mm', type: 'slot', width: 20, height: 4 }
            ],
            hole: [
                { name: '插孔5mm', type: 'hole', width: 5, height: 5 },
                { name: '插孔8mm', type: 'hole', width: 8, height: 8 }
            ]
        };
        vm.activeCategory = 'hanger';

        vm.cutline = { width: 74, height: 84 };
        vm.linked = false;

        vm.placed = [];
        vm.selected = null;
        vm.saveError = '';
        vm.physicalSizeText = '';

        // 组件绑定的 part 在控制器构造后才可用，初始化统一放在 $onInit
        vm.$onInit = function () {
            // TODO: 图片刀线尺寸接入后端后替换为接口数据
            vm.cutline = {
                width: positiveNumber(vm.part && vm.part.cutlineWidth) || 74,
                height: positiveNumber(vm.part && vm.part.cutlineHeight) || 84
            };
            cutlineRatio = ratioOf(vm.cutline);
            initPlacedComponents();
            updatePhysicalSize();
        };

        $scope.selectCategory = function (category) {
            vm.activeCategory = category.key;
        };

        $scope.addComponent = function (option) {
            var component = createPlaced(option, findFreePosition(option));
            vm.placed.push(component);
            vm.selected = component;
            vm.saveError = '';
            validateAll();
            updatePhysicalSize();
        };

        $scope.selectPlaced = function (component) {
            vm.selected = vm.selected === component ? null : component;
        };

        $scope.removePlaced = function (event, component) {
            event.stopPropagation();
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-component-delete.html',
                controller: 'EditorStructureComponentDeleteController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window editor-structure-modal-window-sm',
                resolve: {
                    name: [function () {
                        return component.name;
                    }]
                }
            }).result.then(function () {
                var index = vm.placed.indexOf(component);
                if (index !== -1) {
                    vm.placed.splice(index, 1);
                }
                if (vm.selected === component) {
                    vm.selected = null;
                }
                validateAll();
                updatePhysicalSize();
            });
        };

        $scope.openRules = function () {
            $uibModal.open({
                templateUrl: 'app/entities/editor-structure/components/editor-structure-component-rules.html',
                controller: 'EditorStructureComponentRulesController',
                controllerAs: 'vm',
                backdropClass: 'editor-structure-modal-backdrop',
                windowClass: 'editor-structure-modal-window editor-structure-modal-window-rules'
            });
        };

        $scope.toggleCutlineLink = function () {
            vm.linked = !vm.linked;
            if (vm.linked) {
                cutlineRatio = ratioOf(vm.cutline);
            }
        };

        $scope.onCutlineChange = function (dimension) {
            vm.saveError = '';
            if (!(positiveNumber(vm.cutline.width) && positiveNumber(vm.cutline.height))) {
                validateAll();
                return;
            }
            if (vm.linked) {
                if (dimension === 'width') {
                    vm.cutline.height = round1(vm.cutline.width / cutlineRatio);
                } else {
                    vm.cutline.width = round1(vm.cutline.height * cutlineRatio);
                }
            }
            validateAll();
            updatePhysicalSize();
        };

        $scope.onPlacedChange = function () {
            vm.saveError = '';
            validateAll();
            updatePhysicalSize();
        };

        $scope.markerStyle = function (component) {
            var width = positiveNumber(vm.cutline.width) || 1;
            var height = positiveNumber(vm.cutline.height) || 1;
            return {
                left: (component.x / width * 100) + '%',
                top: (component.y / height * 100) + '%'
            };
        };

        $scope.startDrag = function (event, component) {
            if (event.button !== 0) {
                return;
            }
            event.preventDefault();
            vm.selected = component;
            stopDrag();

            var artwork = $element[0].querySelector('.editor-structure-component-artwork');
            if (!artwork) {
                return;
            }
            var rect = artwork.getBoundingClientRect();
            var scaleX = positiveNumber(vm.cutline.width) / rect.width;
            var scaleY = positiveNumber(vm.cutline.height) / rect.height;
            var startX = event.clientX;
            var startY = event.clientY;
            var originX = component.x;
            var originY = component.y;

            var move = function (moveEvent) {
                component.x = round1(originX + (moveEvent.clientX - startX) * scaleX);
                component.y = round1(originY + (moveEvent.clientY - startY) * scaleY);
                validateAll();
                updatePhysicalSize();
                $scope.$applyAsync();
            };
            var up = function () {
                stopDrag();
                $scope.$applyAsync();
            };

            $document.on('mousemove', move);
            $document.on('mouseup', up);
            stopDrag = function () {
                $document.off('mousemove', move);
                $document.off('mouseup', up);
                stopDrag = angular.noop;
            };
        };

        $scope.startResize = function (event, component) {
            event.preventDefault();
            event.stopPropagation();
            stopDrag();

            var artwork = $element[0].querySelector('.editor-structure-component-artwork');
            if (!artwork) {
                return;
            }
            var rect = artwork.getBoundingClientRect();
            var scaleX = (positiveNumber(vm.cutline.width) || 1) / rect.width;
            var scaleY = (positiveNumber(vm.cutline.height) || 1) / rect.height;
            var startX = event.clientX;
            var startY = event.clientY;
            var originWidth = component.width;
            var originHeight = component.height;

            var move = function (moveEvent) {
                // 控制点在组件右下角，拖拽量按两端换算为尺寸增量
                component.width = Math.max(0.5,
                    round1(originWidth + (moveEvent.clientX - startX) * scaleX * 2));
                component.height = Math.max(0.5,
                    round1(originHeight + (moveEvent.clientY - startY) * scaleY * 2));
                validateAll();
                updatePhysicalSize();
                $scope.$applyAsync();
            };
            var up = function () {
                stopDrag();
                $scope.$applyAsync();
            };

            $document.on('mousemove', move);
            $document.on('mouseup', up);
            stopDrag = function () {
                $document.off('mousemove', move);
                $document.off('mouseup', up);
                stopDrag = angular.noop;
            };
        };

        $scope.cancel = function () {
            stopDrag();
            vm.onClose({ result: null });
        };

        $scope.save = function () {
            stopDrag();
            if (!validateAll()) {
                vm.saveError = '存在不符合放置规则的组件，请调整后再保存';
                return;
            }
            // TODO: 组件保存接口接入后，改为提交组件 ID、坐标与尺寸
            vm.onClose({
                result: {
                    components: vm.placed.map(function (component) {
                        return component.name;
                    })
                }
            });
        };

        $scope.$on('$destroy', function () {
            stopDrag();
        });

        function initPlacedComponents() {
            var names = (vm.part && vm.part.components) || [];
            names.forEach(function (name, index) {
                var option = findOption(name) || { name: name, type: 'hanger', width: 10, height: 10 };
                vm.placed.push(createPlaced(option, {
                    x: vm.cutline.width / 2,
                    y: 4 + index * 12
                }));
            });
            validateAll();
        }

        function createPlaced(option, position) {
            return {
                id: nextId++,
                name: option.name,
                type: option.type,
                width: round1(option.width),
                height: round1(option.height),
                x: round1(position.x),
                y: round1(position.y),
                error: ''
            };
        }

        function findOption(name) {
            var found = null;
            angular.forEach(vm.catalog, function (options) {
                angular.forEach(options, function (option) {
                    if (!found && option.name === name) {
                        found = option;
                    }
                });
            });
            return found;
        }

        function findFreePosition(option) {
            var step = 10;
            var center = { x: vm.cutline.width / 2, y: vm.cutline.height / 2 };
            var candidates = [center];
            var x;
            var y;
            for (y = step; y < vm.cutline.height; y += step) {
                for (x = step; x < vm.cutline.width; x += step) {
                    candidates.push({ x: x, y: y });
                }
            }
            for (var index = 0; index < candidates.length; index += 1) {
                var candidate = candidates[index];
                var occupied = vm.placed.some(function (component) {
                    return overlaps(
                        { x: candidate.x, y: candidate.y, width: option.width, height: option.height },
                        component
                    );
                });
                if (!occupied) {
                    return candidate;
                }
            }
            return center;
        }

        function validateAll() {
            var valid = true;
            vm.placed.forEach(function (component) {
                if (!validateComponent(component)) {
                    valid = false;
                }
            });
            return valid;
        }

        function validateComponent(component) {
            var reasons = [];
            var width = positiveNumber(vm.cutline.width);
            var height = positiveNumber(vm.cutline.height);

            // TODO: 基于刀线轮廓的精确放置规则需接入后端/刀线图解析后实现，目前按外接矩形校验
            if (!(width && height) ||
                component.x < 0 || component.x > width ||
                component.y < 0 || component.y > height) {
                reasons.push('组件需位于图片刀线范围内');
            }
            if (!(component.width > 0) || !(component.height > 0)) {
                reasons.push('组件尺寸需大于 0');
            } else if (vm.placed.some(function (other) {
                return other !== component && overlaps(component, other);
            })) {
                reasons.push('组件之间不可重叠');
            }
            component.error = reasons.length ? reasons[0] : '';
            return !component.error;
        }

        function overlaps(first, second) {
            var distance = Math.sqrt(Math.pow(first.x - second.x, 2) + Math.pow(first.y - second.y, 2));
            var radius = (Math.max(first.width, first.height) + Math.max(second.width, second.height)) / 2;
            return distance < radius;
        }

        function updatePhysicalSize() {
            // TODO: 实物尺寸受组件大小/位置影响的计算规则需与后端对齐
            var width = positiveNumber(vm.part && vm.part.physicalWidth) || positiveNumber(vm.cutline.width);
            var height = positiveNumber(vm.part && vm.part.physicalHeight) || positiveNumber(vm.cutline.height);
            var cutlineWidth = positiveNumber(vm.cutline.width) || width;
            var cutlineHeight = positiveNumber(vm.cutline.height) || height;
            var minX = 0;
            var minY = 0;
            var maxX = cutlineWidth;
            var maxY = cutlineHeight;

            vm.placed.forEach(function (component) {
                minX = Math.min(minX, component.x - component.width / 2);
                minY = Math.min(minY, component.y - component.height / 2);
                maxX = Math.max(maxX, component.x + component.width / 2);
                maxY = Math.max(maxY, component.y + component.height / 2);
            });

            vm.physicalWidth = Math.ceil((maxX - minX) * width / cutlineWidth);
            vm.physicalHeight = Math.ceil((maxY - minY) * height / cutlineHeight);
            vm.physicalSizeText = vm.physicalWidth + 'mm * ' + vm.physicalHeight + 'mm';
        }

        function positiveNumber(value) {
            var number = parseFloat(value);
            return isFinite(number) && number > 0 ? number : 0;
        }

        function ratioOf(size) {
            var width = positiveNumber(size.width);
            var height = positiveNumber(size.height);
            return width && height ? width / height : 1;
        }

        function round1(value) {
            return Math.round(value * 10) / 10;
        }
    }
})();
